import { render, staticRenderFns } from "./zidProducts.vue?vue&type=template&id=606ce304&scoped=true&"
import script from "./zidProducts.vue?vue&type=script&lang=js&"
export * from "./zidProducts.vue?vue&type=script&lang=js&"
import style0 from "./zidProducts.vue?vue&type=style&index=0&id=606ce304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ce304",
  null
  
)

export default component.exports